import { isEmpty } from 'lodash'
import sjt from 'sesajstools'
const { hasProp } = sjt

const requiredText = 'Ce champ est obligatoire'

/**
 * Retourne une fonction de validation
 * @param {Object} [options]
 * @param {string[]} [options.requiredFields] Liste des champs requis
 * @param {string[]} [options.jsonFields] Liste des champs qui doivent contenir du json valide (si la valeur est une string)
 * @returns {validateFn}
 */
const validate = ({
  requiredFields = [],
  jsonFields = []
}) => values => {
  const errors = {}
  for (const key of requiredFields) {
    if (isEmpty(values[key])) {
      errors[key] = requiredText
    }
  }

  for (const key of jsonFields) {
    if (hasProp(values, key)) {
      const value = values[key]
      if (typeof value === 'string') {
        try {
          JSON.parse(value)
        } catch (err) {
          errors[key] = 'Le JSON est invalide'
        }
      }
    }
  }

  return errors
}

export default validate

/**
 * @callback validateFn
 * @param {Object} values
 * @return {Object} errors Les clés sont les clés de values qui posent pb, la valeur est une string avec l'erreur
 */
